import React from 'react';

import { ModalCloseButton as ChakraModalCloseButton } from '@chakra-ui/react';

import { CloseIcon } from '../../icons';

export const ModalCloseButton = ({
  'data-test-id': dataTestId,
}: {
  'data-test-id'?: string;
}) => (
  <ChakraModalCloseButton data-test-id={dataTestId}>
    <CloseIcon />
  </ChakraModalCloseButton>
);
